import { Navigate, useParams } from 'react-router-dom';
import type { AnalyseEngine } from '@/hooks/analyseOverview.utils';

/**
 * Tegningsanalyse and Udbudsanalyse each had their own page before they were merged into
 * AI-analyse. Their addresses are in browser histories, bookmarks and mails, so they keep
 * working and land on the same analysis rather than on a dead page.
 */
export function LegacyAnalysisRedirect({ engine }: { engine: AnalyseEngine }) {
    const { id } = useParams<{ id: string }>();
    return <Navigate to={id ? `/ai-analyse/${engine}/${id}` : '/ai-analyse'} replace />;
}
